import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { TrussGroup } from '@paragon/contract-library';
import { forceArray } from '@paragon/utilities';

export interface TrussGroupStore {
  [key: string]: TrussGroup;
}

const initialState: Readonly<TrussGroupStore> = {};

const trussGroupsSlice = createSlice({
  name: 'trussGroups',
  initialState,
  reducers: {
    trussGroupsLoaded: (state, action: PayloadAction<TrussGroup | readonly TrussGroup[]>) => {
      const trussGroups = forceArray(action.payload);
      for (const trussGroup of trussGroups) {
        state[trussGroup.guid] = castDraft(trussGroup);
      }
    },
    trussGroupsDeleted: (state, action: PayloadAction<string | readonly string[]>) => {
      const guids = forceArray(action.payload);
      for (const guid of guids) {
        delete state[guid];
      }
    },
  },
});

export const { trussGroupsLoaded, trussGroupsDeleted } = trussGroupsSlice.actions;
export const trussGroups = trussGroupsSlice.reducer;
